import { styled } from "@styles";
import { Accordion, Card } from "react-bootstrap";

export const Wrapper = styled(Accordion)``;

export const OrderShippingDetailCard = styled(Card)`
  margin-bottom: 1rem;
`;

export const OrderShippingDetailCardHeader = styled(Card.Header)``;

export const OrderShippingDetailCardHeaderTitle = styled.p`
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  margin: 0;
`;

export const OrderShippingDetailCardBody = styled(Card.Body)``;

export const OrderShippingDetailMutedSubtitle = styled.small`
  color: #ddd;
  float: left;
`;

export const OrderShippingDetailP = styled.p`
  text-align: left;
`;

export const OrderShippingDetailH5 = styled.h5``;